import { Video, MapPin, CalendarClock } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const FORMATS = [
  {
    icon: Video,
    title: "Online",
    items: ["One-on-one video lessons", "Anywhere in the world", "Materials shared after each session"],
    testid: "format-online",
  },
  {
    icon: MapPin,
    title: "In person",
    items: ["Katy & Houston area", "At your home or an agreed location", "Ideal for children and teens"],
    testid: "format-inperson",
  },
  {
    icon: CalendarClock,
    title: "Flexible",
    items: ["Flexible scheduling, weekdays and weekends", "Frequency adapted to your goals", "A program that evolves with you"],
    testid: "format-flexible",
  },
];

export default function Formats() {
  return (
    <section id="formules" className="py-24 lg:py-36" data-testid="formats-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <Eyebrow>Lesson formats</Eyebrow>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-6 leading-tight max-w-2xl">
            At your pace, <span className="italic text-gold">wherever you are.</span>
          </h2>
        </Reveal>
        <div className="mt-16 grid md:grid-cols-3 gap-px bg-sand border border-sand">
          {FORMATS.map((f, i) => {
            const Icon = f.icon;
            return (
              <Reveal key={f.title} delay={i * 0.12} className="bg-cream">
                <div className="p-10 lg:p-12 h-full" data-testid={f.testid}>
                  <Icon size={26} strokeWidth={1.5} className="text-gold" />
                  <h3 className="font-serif text-3xl mt-6">{f.title}</h3>
                  <ul className="mt-6 space-y-3">
                    {f.items.map((item) => (
                      <li key={item} className="flex gap-3 text-sm text-navy/70 leading-relaxed">
                        <span className="text-gold mt-0.5">—</span>
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.2}>
          <p className="mt-10 text-sm text-navy/60" data-testid="formats-pricing-note">
            Rates are provided on request, based on the format and frequency you choose. First discovery chat with no obligation.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
